import { render, staticRenderFns } from "./QuestionsMobile.vue?vue&type=template&id=bbbcbeea&scoped=true&"
import script from "./QuestionsMobile.vue?vue&type=script&lang=ts&"
export * from "./QuestionsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsMobile.vue?vue&type=style&index=0&id=bbbcbeea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbcbeea",
  null
  
)

component.options.__file = "QuestionsMobile.vue"
export default component.exports